<template>
<div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item" @click="$router.push('/suppliers')" style="cursor: pointer">Instaladores</li>
        <li class="breadcrumb-item active">Veificación de tecnologías </li>
      </ol>
    </nav>
    <div class="container-fluid">
      <div class="filter-zone row justify-content-md-center" style="margin-top:20px;">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <h5 class="card-title">Buscar Proveedor</h5>
              <div class="row">
                <div class="col-md-11">
                  <input type="text" placeholder="Buscar proveedor..." class="form-control" v-model="search" v-on:keyup.enter="searchSupplier()">
                </div>
                <div class="col-md-1">
                  <button class="form-control btn btn-success btn-raised" style="font-size: 1px;padding-bottom: 2%;" v-on:click="searchSupplier()" :disabled="buscando">
                    <em class="material-icons" style="margin-top: -5px;">search</em>
                  </button>
                </div>
              </div>
              <small>Criterios de busqueda: SID, UID, Nombre, Razón social, Nombre Comercial y Tecnología.</small>
              <table class="table table-hover" style="padding-top: 20px">
                <tr>
                  <th style="text-align: left!important">SID</th>
                  <th style="text-align: left!important">UID</th>
                  <th style="text-align: left!important">Nombre/Razón Social</th>
                  <th style="text-align: left!important">Nombre Comercial</th>
                  <th style="text-align: left!important">Proveedor desde</th>
                  <th style="text-align: left!important">F. Solicitud de Verificación</th>
                  <th style="text-align: left!important">Tecnología</th>
                  <th style="text-align: left!important">TT (días)</th>
                  <th style="text-align: left!important">Semáforo</th>
                </tr>
                <template v-for="renglon in spl_technologies">

                    <tr style="cursor: pointer">
                        <td>
                            <router-link :to="`/suppliers/${renglon.sid}`">
                            {{renglon.sid}}
                            </router-link>
                        </td>
                        <td>{{renglon.uid}}</td>
                        <td>{{renglon.nombre}}</td>
                        <td>{{renglon.comercial}}</td>
                        <td>{{renglon.supplier_since | human_date}}</td>
                        <td>{{renglon.request_date | human_date }}</td>
                        <td>{{renglon.technology_name}}</td>
                        <td>{{renglon.TT == null || renglon.TT == "0000-00-00 00:00:00" ? '-' : renglon.TT}}</td>
                        <td><div class="triage" :class="setTriageColor(renglon.TT)"></div></td>
                    </tr>

                </template>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="js">
import * as moment from 'moment'
const status = 1;
export default {
    name: 'suppliers_not_verified',
     filters: {
          human_date(date) {
              if(date != null && date != '0000-00-00 00:00:00'){
                  return moment(date).lang("es").format("D MMM YYYY");
              } else {
                  return '-'
              }
          }
      },
    props: [],
    data() {
      return {
        data: [],
        search: '',
        spl_technologies: [],
        buscando: false,
        slas: {},
      }
    },
    async created() {
      const {data} = await axios.get('/api/sla_df_verification');
      this.slas = data;
      this.getTechnologiesNotVerified();
    },
    methods: {
        getTechnologiesNotVerified(){
            axios.post( '/api/suppliers/technologies/notVerified', {
                status: status,
            })
            .then(response => {
                this.spl_technologies = response.data.spl_technologies;
            })
            .catch(error => {
              this.errorNotif(error.response.data.message, error.response.data.errors);
            });
        },
        searchSupplier() {
            if(this.search != ''){
                if(this.buscando == false){
                    this.buscando=true;
                    axios.post( '/api/suppliers/technologies/notVerified/search', {
                        status: status,
                        search: this.search,
                    })
                    .then(response => {
                    this.spl_technologies = response.data.spl_technologies;
                    this.buscando = false;
                    }).catch(error => {
                        this.errorNotif(error.response.data.message, error.response.data.errors);
                    });
                }
            } else {
                this.getTechnologiesNotVerified();
            }
        },
        getStatus($status){
            switch ($status) {
            case 1:
                return 'Instaladores no activados';
                break;
            case 2:
                return 'Instaladores activados, no verificados';
                break;
            case 3:
                return 'Instaladores en proceso de verificación';
                break;
            case 4:
                return 'Verificados, sin proyecto fondeado o sin solicitudes';
                break;
            case 5:
                return 'Con proyecto fondeado, más de 3 meses sin solicitud';
                break;
            case 6:
                return 'Con proyecto fondeado, más de 1 mes sin solicitud y menos o igual a 3 meses';
                break;
            case 7:
                return 'Con proyecto fondeado o sin solicitud por un mes o menos';
                break;
            default:
                return 'Indefinido';
                break;
            }
        },
        setTriageColor(TT) {
          let redValue = parseInt(this.slas.sla_verified[2].val);
          let yellowValue = parseInt(this.slas.sla_verified[3].val);
          try {
            if(TT > redValue ){
              return 'triage-red';
            } else if(TT > yellowValue){
              return 'triage-yellow';
            } else {
              return 'triage-green';
            }
          } catch(err) {
            return '';
          }
      }
    },
    computed: {
      //TO DO
    }
}
</script>

<style>
  .triage {
      width: 1.5rem;
      height: 1.5rem;
      background-color: #ccc;
      margin-left: 1.5rem;
      border-radius: 5pc;
      -webkit-box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14), 0 3px 1px -2px rgba(0,0,0,0.12), 0 1px 5px 0 rgba(0,0,0,0.2);
      box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14), 0 3px 1px -2px rgba(0,0,0,0.12), 0 1px 5px 0 rgba(0,0,0,0.2);
  }

  .triage-red {
    background-color: red !important;
  }
  .triage-yellow {
    background-color: yellow !important;
  }
  .triage-green {
    background-color: green !important;
  }
</style>